module.exports = __webpack_public_path__ + "static/media/eye-icon.78ba2980.svg";